module.exports = __webpack_public_path__ + "img/loading-bg.dec0a40b.png";